import { useCallback, useState } from 'react';
import { getNeighbors, loadLibraryAssetIds } from './library-neighbors';

// Quick-Look-Overlay-State + Neighbor-Navigation (Session 30). Hält die aktuell
// im Overlay gezeigte Asset-ID; next/prev rechnen die Nachbarn frisch aus der
// sessionStorage-Liste (gleiche Quelle wie AssetDetailPage J/K), Ränder = no-op
// (kein Wrap). Genutzt von LibraryPage.
export interface QuickLook {
  /** Aktuell im Overlay gezeigte Asset-ID, oder null wenn geschlossen. */
  openId: string | null;
  isOpen: boolean;
  open: (id: string) => void;
  close: () => void;
  next: () => void;
  prev: () => void;
}

export function useQuickLook(): QuickLook {
  const [openId, setOpenId] = useState<string | null>(null);

  const open = useCallback((id: string) => setOpenId(id), []);
  const close = useCallback(() => setOpenId(null), []);

  const go = useCallback((dir: 'next' | 'prev') => {
    setOpenId((cur) => {
      if (cur === null) return cur;
      const n = getNeighbors(loadLibraryAssetIds(), cur);
      const dest = dir === 'next' ? n.next : n.prev;
      return dest ?? cur; // Rand: kein Nachbar → no-op (kein Wrap)
    });
  }, []);

  const next = useCallback(() => go('next'), [go]);
  const prev = useCallback(() => go('prev'), [go]);

  return { openId, isOpen: openId !== null, open, close, next, prev };
}
